export default {
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement des modifications.",
    successfully_saved: 'Enregistré avec succès.',
  },
  form: {
    has_multiple_locations: {
      label: 'Définir des emplacements différents pour la semaine',
    },
  },
  labels: {
    day_location: '{{day}} emplacement {{index}}',
    selected_days: 'Jours sélectionnés',
    orders_paused: 'Commandes en pause',
    open_time: "Heure d'ouverture",
    close_time: 'Heure de fermeture',
  },
  buttons: {
    save: 'Enregistrer',
  },
};
